export default __webpack_public_path__ + "static/media/Imagem3.7e485ac9.png";